import {
  atsJobDetailsApiActions,
  getAtsJobDetails,
} from '@/store/atsJobDetails';
import { useDispatch, useSelector } from 'react-redux';

export const useApplicationHelper = () => {
  const dispatch = useDispatch();
  const { currentApplication } = useSelector(getAtsJobDetails);
  const { isLoading, data: applicationData } = currentApplication;

  const refetchApplication = () => {
    if (!applicationData?.id) return;
    dispatch(
      atsJobDetailsApiActions('getCurrentApplication', {
        pathParams: { applicationId: applicationData?.id },
        requestConfig: { params: { include: ['stage_actions'] } },
        isBackground: true,
      })
    );
  };

  return { applicationData, isLoading, refetchApplication };
};
